module.exports = {
  "hierarchy": {},
  "props": {
    "default": {
      "headerHeight": 44,
      "rowHeight": 44
    }
  }
}